<script lang="ts">
  import type { HTMLAnchorAttributes } from "svelte/elements";

  interface Props extends HTMLAnchorAttributes {
    text?: string;
    variant?: "highlight" | "primary" | "secondary" | "inherit";
    size?: "sm" | "base" | "lg";
    color?: string | undefined;
    tab?: boolean;
  }

  let {
    href,
    text = "",
    variant = "highlight",
    size = "sm",
    color = "pri-800",
    tab = false,
    children,
    class: className,
    ...rest
  }: Props = $props();
</script>

<a
  {...rest}
  target={tab ? "_blank" : rest.target}
  rel={tab ? "noreferrer noopener" : rest.rel}
  class={[
    "inline-flex cursor-pointer items-center truncate focus-ring transition-all ease-out",
    variant === "inherit" && "text-inherit no-underline",
    variant === "highlight" && "text-pri-800 underline-offset-2 hover:underline",
    variant === "primary" && "text-mono-900 underline-offset-2 hover:underline",
    !variant && color && `text-${color}`,
    !variant && !color && "text-pri-800",
    size === "sm" ? "text-sm" : size === "lg" ? "text-lg" : "text-base",
    className,
  ]}
  {href}>{text}{@render children?.()}</a
>
